import {Field, FIELD_TYPES, Model} from '../../vue-ocom/schema';

export default Model('truck_size', {
  verbose_name: "Truck Size",
  verbose_name_plural: "Truck Sizes",
  fields: [
    Field('id', {label: 'ID', primary_key: true, readonly: true, hide: false, field_type: FIELD_TYPES.AutoNumber}),

    Field('product', {
      label: "Product",
      primary_key: false,
      readonly: false,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.ForeignKey,
      ref_field_type: "CodeProduct", ref_display_field: "code",
      default: () => {
        return null;
      }
    }),
    Field('capacity', {
      label: "Capacity",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Number,
      default: () => {
        return null;
      }
    }),
    Field('active_start_date', {
      label: "Active Start Date",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return new Date();
      }
    }),
    Field('active_end_date', {
      label: "Active End Date",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return null;
      }
    }),
    Field('modified_date', {
      label: "Modified Date",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return null;
      }
    }),
    Field('created_date', {
      label: "Created Date",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return null;
      }
    }),
  ]
});
